(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-box"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ms-box')) {
  customElements.define('ms-box', class extends HTMLElement {
    connectedCallback() {
      if (this.gotowe) return; this.gotowe = true;
      this.sloty = +this.dataset.sloty || 6;
      this.cena = +this.dataset.cena || 0;
      this.ile = new Map();
      this.kafle = [...this.querySelectorAll('.ms-bp')];
      this.btn = this.querySelector('.ms-box__add');
      this.pola = [...this.querySelectorAll('[data-pole]')];
      this.slots = [...this.querySelectorAll('.ms-box__slot')];
      this.kafle.forEach((k) => {
        k.querySelector('[data-plus]').addEventListener('click', () => this.zmien(k, 1));
        k.querySelector('[data-minus]').addEventListener('click', () => this.zmien(k, -1));
      });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
          if (e && e.source === 'product-form' && String(e.productVariantId) === this.dataset.wariant) { this.ile.clear(); this.odswiez(); }
        });
      }
      this.odswiez();
    }
    disconnectedCallback() { if (this.unsub) this.unsub(); }
    suma() { let n = 0; this.ile.forEach((v) => (n += v)); return n; }
    zl(grosze) { const v = grosze / 100; return (v % 1 ? v.toFixed(2).replace('.', ',') : v) + ' zł'; }
    zmien(k, d) {
      const n = this.suma();
      if (d > 0 && n >= this.sloty) return;
      const v = (this.ile.get(k) || 0) + d;
      if (v <= 0) this.ile.delete(k); else this.ile.set(k, v);
      this.odswiez();
    }
    odswiez() {
      const n = this.suma(); let osobno = 0; const lista = [];
      this.kafle.forEach((k) => {
        const c = this.ile.get(k) || 0;
        k.querySelector('output').textContent = c;
        k.classList.toggle('is-on', c > 0);
        k.querySelector('[data-minus]').disabled = c === 0;
        if (!k.classList.contains('ms-bp--brak')) k.querySelector('[data-plus]').disabled = n >= this.sloty;
        for (let i = 0; i < c; i++) { lista.push(k); osobno += +k.dataset.cena; }
      });
      this.slots.forEach((s, i) => { const k = lista[i]; s.innerHTML = k && k.dataset.img ? '<img src="' + k.dataset.img + '" alt="">' : ''; s.classList.toggle('is-on', !!k); });
      const sklad = []; this.kafle.forEach((k) => { const c = this.ile.get(k) || 0; if (c) sklad.push(k.dataset.nazwa + (c > 1 ? ' ×' + c : '')); }); this.pola.forEach((p) => { p.value = sklad.join(', '); p.disabled = n !== this.sloty; });
      this.querySelector('[data-cnt]').textContent = 'Wybrano ' + n + ' z ' + this.sloty;
      this.querySelector('[data-osobno]').textContent = n ? this.zl(osobno) : '—';
      this.querySelector('[data-oszcz]').textContent = n === this.sloty && osobno > this.cena ? this.zl(osobno - this.cena) : '—';
      if (!this.btn) return;
      const reszta = this.sloty - n;
      this.btn.disabled = n !== this.sloty;
      const slowo = reszta === 1 ? ' mydło' : reszta < 5 ? ' mydła' : ' mydeł';
      this.btn.querySelector('span').textContent = n === this.sloty ? (this.dataset.tekst || 'Dodaj BOX do koszyka') + ' · ' + this.dataset.cenaTxt : n === 0 ? 'Wybierz ' + this.sloty + ' mydeł' : 'Wybierz jeszcze ' + reszta + slowo;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-kreator-zestawu"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ms-kreator')) {
  customElements.define('ms-kreator', class extends HTMLElement {
    connectedCallback() {
      if (this.gotowe) return; this.gotowe = true;
      this.min = +this.dataset.min || 0; this.max = +this.dataset.max || Infinity;
      this.kokarda = this.querySelector('[data-kokarda]');
      this.kroki = [...this.querySelectorAll('[data-krok]')];
      this.poz = [...this.querySelectorAll('[data-poz]')];
      this.ile = new Map(); this.kolej = [];
      this.btn = this.querySelector('[data-dodaj]');
      this.opak = this.querySelector('[data-opak]');
      this.opakW = this.querySelector('[data-opak-wariant]');
      this.poz.forEach((p) => {
        p.querySelectorAll('[data-plus]').forEach((b) => b.addEventListener('click', () => this.zmien(p, 1)));
        p.querySelector('[data-minus]').addEventListener('click', () => this.zmien(p, -1));
        const sel = p.querySelector('select[data-wariant]');
        if (sel) sel.addEventListener('change', () => this.odswiez());
      });
      if (this.opak) this.opak.addEventListener('change', () => this.odswiez());
      if (this.opakW && this.opakW.tagName === 'SELECT') this.opakW.addEventListener('change', () => this.odswiez());
      this.btn.addEventListener('click', () => this.dodaj());
      this.sum = this.querySelector('.ms-kz__sum'); this.tlo = this.querySelector('[data-tlo]');
      this.pas = this.querySelector('[data-pas]');
      this.querySelector('[data-pas-btn]').addEventListener('click', () => this.otworz(true));
      this.tlo.addEventListener('click', () => this.otworz(false));
      this.querySelector('[data-zamknij]').addEventListener('click', () => this.otworz(false));
      this.addEventListener('keyup', (e) => { if (e.key === 'Escape') this.otworz(false); });
      this.mob = window.matchMedia('(max-width: 899px)');
      if (this.mob.addEventListener) this.mob.addEventListener('change', () => { if (!this.mob.matches) this.otworz(false); });
      this.kat = [...this.querySelectorAll('.ms-kz__kat')];
      this.querySelectorAll('[data-zakl]').forEach((z) => z.addEventListener('click', () => this.pokazKrok(+z.dataset.zakl, z.classList.contains('ms-kz__dalej'))));
      this.gora = () => {
        const h = document.querySelector('.section-header');
        const r = h ? h.getBoundingClientRect() : null;
        const top = h ? Math.round(h.offsetHeight) : 0;
        if (this.pas && this.pas.style.top !== top + 'px') this.pas.style.top = top + 'px';
      };
      { const hh = document.querySelector('.section-header'); if (hh && window.ResizeObserver) new ResizeObserver(this.gora).observe(hh); }
      window.addEventListener('resize', this.gora);
      this.gora();
      this.odswiez();
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.gora); window.removeEventListener('resize', this.gora); }
    otworz(tak) {
      if (tak && !this.mob.matches) { this.sum.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      this.classList.toggle('is-otwarte', tak); this.tlo.hidden = !tak;
      document.body.classList.toggle('ms-kz-blokada', tak);
      if (tak) this.querySelector('[data-zamknij]').focus();
    }
    pokazKrok(i, przewin) {
      this.kat.forEach((z, n) => { z.classList.toggle('is-akt', n === i); z.setAttribute('aria-selected', n === i); });
      this.kroki.forEach((k, n) => k.classList.toggle('is-akt', n === i));
      const cel = this.querySelector('.ms-kz__kategorie') || this;
      const top = cel.getBoundingClientRect().top;
      if (przewin || top < 0) window.scrollBy({ top: top - (this.pas ? this.pas.getBoundingClientRect().bottom : 90) - 8, behavior: 'smooth' });
    }
    zl(g) { const v = g / 100; return (v % 1 ? v.toFixed(2).replace('.', ',') : v) + ' zł'; }
    wariant(p) {
      const el = p.querySelector('[data-wariant]');
      const o = el.tagName === 'SELECT' ? el.selectedOptions[0] : el;
      return { id: +el.value, cena: +o.dataset.cena, opis: o.dataset.opis || '' };
    }
    opakowanie() {
      if (!this.opak || !this.opak.checked || !this.opakW) return null;
      const o = this.opakW.tagName === 'SELECT' ? this.opakW.selectedOptions[0] : this.opakW;
      return { id: +this.opakW.value, cena: +o.dataset.cena, opis: o.dataset.opis || 'Opakowanie prezentowe' };
    }
    pelny(k) { const m = +k.dataset.max || Infinity; return this.wKroku(k) >= m || this.suma() >= this.max; }
    odm(n) { const d = n % 10, s = n % 100; return n === 1 ? 'produkt' : (d >= 2 && d <= 4 && (s < 12 || s > 14)) ? 'produkty' : 'produktów'; }
    wKroku(k) { let n = 0; k.querySelectorAll('[data-poz]').forEach((p) => (n += this.ile.get(p) || 0)); return n; }
    suma() { let n = 0; this.ile.forEach((v) => (n += v)); return n; }
    zmien(p, d) {
      const k = p.closest('[data-krok]');
      if (d > 0 && this.pelny(k)) return;
      const v = (this.ile.get(p) || 0) + d;
      if (v <= 0) this.ile.delete(p); else this.ile.set(p, v);
      if (d > 0) { this.kolej.push(p); this.nowy = p; } else { const i = this.kolej.lastIndexOf(p); if (i >= 0) this.kolej.splice(i, 1); this.nowy = null; }
      if (d > 0 && this.kokarda) { this.kokarda.classList.remove('is-hop'); void this.kokarda.offsetWidth; this.kokarda.classList.add('is-hop'); }
      this.odswiez();
    }
    problem() {
      for (const k of this.kroki) {
        const n = this.wKroku(k), mn = +k.dataset.min;
        if (n < mn) return 'Wybierz jeszcze ' + (mn - n) + ' w kroku „' + k.dataset.tytul + '”.';
      }
      const n = this.suma();
      if (n === 0) return 'Wybierz produkty do zestawu.';
      if (n < this.min) return 'Dodaj jeszcze ' + (this.min - n) + ' ' + this.odm(this.min - n) + ', aby powstał zestaw.';
      return '';
    }
    odswiez() {
      let razem = 0; const lista = this.querySelector('[data-wybrane]'); const li = [];
      this.poz.forEach((p) => {
        const c = this.ile.get(p) || 0, w = this.wariant(p);
        p.querySelector('output').textContent = c;
        p.classList.toggle('is-on', c > 0);
        const ptk = p.querySelector('[data-ptk]'); if (ptk) ptk.textContent = c || '';
        const dod = p.querySelector('[data-dodaj-1]'), stp = p.querySelector('.ms-stp');
        if (dod && stp) { dod.hidden = c > 0; stp.hidden = c === 0; }
        p.querySelector('[data-minus]').disabled = c === 0;
        p.querySelector('[data-cena-txt]').textContent = this.zl(w.cena);
        const k = p.closest('[data-krok]');
        if (!p.classList.contains('ms-kz__poz--brak')) p.querySelectorAll('[data-plus]').forEach((b) => (b.disabled = this.pelny(k)));
        if (c) { razem += c * w.cena; li.push('<li><span>' + p.dataset.tytul + (w.opis ? ' <small>' + w.opis + '</small>' : '') + (c > 1 ? ' ×' + c : '') + '</span><b>' + this.zl(c * w.cena) + '</b></li>'); }
      });
      const o = this.opakowanie();
      if (o) { razem += o.cena; li.push('<li class="ms-kz__li-opak"><span>' + o.opis + '</span><b>' + this.zl(o.cena) + '</b></li>'); }
      lista.innerHTML = li.length ? li.join('') : '<li class="ms-kz__pusto">Pudełko czeka — dodaj pierwszy produkt.</li>';
      const n = this.suma();
      this.querySelector('[data-licznik]').textContent = n ? n + ' ' + this.odm(n) + ' w pudełku' : 'puste pudełko';
      this.classList.toggle('is-pelne', n > 0);
      this.classList.toggle('is-opak', !!o);
      if (this.pas) {
        const sl = this.querySelector('[data-sloty]');
        const pokaz = this.mob && this.mob.matches ? 5 : 8;
        const ost = this.kolej.slice(-pokaz);
        let h = ost.map((p) => '<span' + (p === this.nowy && p === ost[ost.length - 1] ? ' class="is-nowy"' : '') + '>' + (p.dataset.img ? '<img src="' + p.dataset.img + '" alt="">' : '') + '</span>').join('');
        for (let i = ost.length; i < Math.min(pokaz, 4); i++) h += '<span class="is-puste"></span>';
        if (this.kolej.length > pokaz) h = '<span class="is-wiecej">+' + (this.kolej.length - pokaz) + '</span>' + h;
        sl.innerHTML = h; this.nowy = null;
        this.querySelector('[data-pas-ile]').textContent = n ? n + ' ' + this.odm(n) : 'Pudełko';
        this.querySelector('[data-pas-razem]').textContent = this.zl(razem);
        this.pas.classList.toggle('is-pelny', n > 0);
      }
      this.kat.forEach((z, i) => { const c = this.kroki[i] ? this.wKroku(this.kroki[i]) : 0; const s = z.querySelector('[data-zakl-ile]'); s.textContent = c; s.hidden = !c; });
      this.querySelector('[data-razem]').textContent = this.zl(razem);
      const pr = this.problem();
      this.querySelector('[data-uwaga]').textContent = pr;
      this.btn.disabled = !!pr;
    }
    async dodaj() {
      if (this.problem()) return;
      const nr = this.dataset.nazwa + ' #' + Math.floor(1000 + Math.random() * 9000);
      const prop = {}; prop[this.dataset.etykieta] = nr;
      const items = [];
      this.poz.forEach((p) => { const c = this.ile.get(p) || 0; if (c) items.push({ id: this.wariant(p).id, quantity: c, properties: prop }); });
      const o = this.opakowanie(); if (o) items.push({ id: o.id, quantity: 1, properties: prop });
      const blad = this.querySelector('[data-blad]'); blad.hidden = true;
      this.btn.disabled = true; this.btn.classList.add('loading');
      try {
        const r = await fetch((window.routes ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: this.dataset.sections.split(','), sections_url: window.location.pathname })
        });
        const j = await r.json();
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'Nie udało się dodać zestawu.');
        this.otworz(false);
        const cd = document.querySelector('cart-drawer');
        if (cd && j.sections) { cd.classList.remove('is-empty'); cd.renderContents(j); }
        else window.location = window.routes ? window.routes.cart_url : '/cart';
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ms-kreator', cartData: j });
        this.ile.clear(); this.kolej = []; if (this.opak) this.opak.checked = this.opak.defaultChecked; this.odswiez();
      } catch (e) {
        blad.textContent = e.message; blad.hidden = false;
      } finally { this.btn.classList.remove('loading'); this.odswiez(); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-opinie"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ms-karuzela')) {
  customElements.define('ms-karuzela', class extends HTMLElement {
    connectedCallback() {
      this.tor = this.querySelector('[data-tor]');
      this.karty = [...this.tor.children].filter((k) => k.matches('.ms-rev'));
      this.kropki = this.querySelector('[data-kropki]');
      this.czas = Math.max(3, +this.dataset.czas || 6) * 1000;
      this.pauza = 0;
      if (this.karty.length < 2) return;
      this.kropki.innerHTML = this.karty.map(() => '<i></i>').join('');
      this.tor.addEventListener('scroll', () => { clearTimeout(this.t); this.t = setTimeout(() => this.kropka(), 80); }, { passive: true });
      ['pointerdown', 'touchstart', 'wheel', 'focusin'].forEach((e) => this.tor.addEventListener(e, () => (this.pauza = Date.now() + 12000), { passive: true }));
      this.tor.addEventListener('mouseenter', () => (this.hover = true));
      this.tor.addEventListener('mouseleave', () => (this.hover = false));
      this.widac = false;
      if ('IntersectionObserver' in window) new IntersectionObserver((e) => { this.widac = e[0].isIntersecting; }, { threshold: 0.5 }).observe(this.tor);
      this.kropka();
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.i = setInterval(() => this.dalej(), this.czas);
    }
    disconnectedCallback() { clearInterval(this.i); }
    widoczne() { return Math.max(1, Math.round(this.tor.clientWidth / this.karty[0].offsetWidth)); }
    indeks() { const x = this.tor.scrollLeft; let n = 0, d = 1e9; this.karty.forEach((k, i) => { const r = Math.abs(k.offsetLeft - this.tor.offsetLeft - x); if (r < d) { d = r; n = i; } }); return n; }
    kropka() { const n = this.indeks(); [...this.kropki.children].forEach((k, i) => k.classList.toggle('is-on', i === n)); this.kropki.hidden = this.tor.scrollWidth <= this.tor.clientWidth + 4; }
    dalej() {
      if (!this.widac || this.hover || Date.now() < this.pauza || document.hidden) return;
      if (this.tor.scrollWidth <= this.tor.clientWidth + 4) return;
      let n = this.indeks() + 1;
      if (n > this.karty.length - this.widoczne()) n = 0;
      this.tor.scrollTo({ left: this.karty[n].offsetLeft - this.tor.offsetLeft, behavior: 'smooth' });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-produkty"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ms-tabs')) {
  customElements.define('ms-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((t, i) => t.addEventListener('click', () => this.pokaz(i)));
    }
    pokaz(i) {
      this.tabs.forEach((t, j) => {
        t.setAttribute('aria-selected', i === j ? 'true' : 'false');
        const p = this.querySelector('#' + CSS.escape(t.getAttribute('aria-controls')));
        if (p) p.hidden = i !== j;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-zapachy"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ms-zapachy')) {
  customElements.define('ms-zapachy', class extends HTMLElement {
    connectedCallback() {
      this.kafle = [...this.querySelectorAll('.ms-sc')];
      this.kafle.forEach((b) => b.addEventListener('click', () => this.pokaz(b)));
      this.querySelectorAll('[data-zamknij]').forEach((b) => b.addEventListener('click', () => this.zamknij()));
    }
    pokaz(b) {
      this.kafle.forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      this.querySelectorAll('.ms-sc-result').forEach((p) => (p.hidden = p.id !== b.dataset.panel));
      const p = this.querySelector('#' + CSS.escape(b.dataset.panel));
      if (p) p.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    zamknij() {
      this.kafle.forEach((x) => x.setAttribute('aria-pressed', 'false'));
      this.querySelectorAll('.ms-sc-result').forEach((p) => (p.hidden = true));
      this.closest('section').scrollIntoView({ behavior: 'smooth' });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
